import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";

import ForgotPasswordOne from "../../components/forgotpassword/ForgotPasswordOne";
import ForgotPasswordTwo from "../../components/forgotpassword/ForgotPasswordTwo";
import ForgotPasswordThree from "../../components/forgotpassword/ForgotPasswordThree";

function ForgotPassword() {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const navigate = useNavigate();

  const location = useLocation();
  const { type } = location.state || "";
  const [email, setEmail] = useState("")
  const [otp, setOtp] = useState("")
  const [newPassword, setPassword] = useState("")
  const [tourDateTimeExpiry, setExpiry] = useState("");
  const [downPayment, setDownPayment] = useState("");
  const [employeeSalary, setEmployeeSalary] = useState("");
  const [tourDateTime, setTourDateTime] = useState("");
  const [bankContractPdf, setPdf] = useState(null);
  const [index, setIndex] = useState(1);
  const [yesOrNo, setYesNo] = useState("yes");
  const [aqdasYes, setAqdasYes] = useState("");

  return (
    <div className="schedule-tour">
      <Link style={{ textDecoration: "none" }} to="/">
        <img src="/img/Logo.svg" className="home-logo" alt="" />
      </Link>

      <div className="container-fluid schedule-tour-container px-0">
        <div className="row px-0 mx-0">
          <div className="col-lg-6 agent-register-form-conatiner d-flex justify-content-center px-0">
            <h2 className="agent-register-heading">
              {index === 1 ? <>Recover Your Account</> : <></>}
              {index === 2 ? <>Recover Your Account</> : <></>}
              {index === 3 ? <>Enter New Password</> : <></>}
            </h2>

            {index === 1 ? (
              <ForgotPasswordOne
                props={{setIndex, type, email, setEmail, aqdasYes, setAqdasYes }}
              />
            ) : index === 2 ? (
              <ForgotPasswordTwo
                props={{ otp, setOtp, setIndex }}
              />
            ) : index === 3 ? (
              <ForgotPasswordThree
              props={{email, otp, setOtp, setIndex, type, newPassword, setPassword, aqdasYes, setAqdasYes}}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="col-md-6 text-center d-none d-lg-block">
            <img
              src="/img/forgot-password-right.png"
              className="img-fluid schedule-tour-right"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
